import { TZ_PLATFORM_DEFAULT } from '../../../constants'
import type { DomainDto } from '../../../dtos/domain'

export interface IJourneyDisplayTimeZone {
    /** IANA zone the journey's dates should be read in. Never the string 'STZ'. */
    tz: string
    /** True when delivery follows each subscriber's own zone, so `tz` is only a stand-in. */
    isSTZ: boolean
}

/**
 * Resolves the zone a journey's dates must be rendered in.
 *
 * Journey dates are stored as wall-clock values paired with `date_time_zone`, so they are
 * meaningless without it — reading one in the viewer's local zone silently relabels the
 * journey with whatever zone the browser happens to sit in. Every surface that displays a
 * journey date must go through here so they agree with one another.
 */
export function resolveJourneyDisplayTimeZone(
    dateTimeZone: string | undefined,
    domain?: Pick<DomainDto, 'timezone'>,
): IJourneyDisplayTimeZone {
    const isSTZ = !dateTimeZone || dateTimeZone.toUpperCase() === 'STZ'

    return {
        isSTZ,
        tz: isSTZ ? (domain?.timezone ?? TZ_PLATFORM_DEFAULT) : dateTimeZone!,
    }
}
